import React, { useState, useCallback } from 'react'
import Cropper from 'react-easy-crop'
import { getCroppedImg } from './imageCropCanvas/canvasUtil'

const UploadImageBuilder = ({ imageUrl, onClose, setCroppedImageSrc, setImageSrc }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [rotation, setRotation] = useState(0)
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }, [])

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        imageUrl,
        croppedAreaPixels,
        rotation
      )
      setCroppedImageSrc(croppedImage)
      onClose() // Close the modal after cropping
    } catch (e) {
      console.error(e)
    }
  }, [imageUrl, croppedAreaPixels, rotation, setCroppedImageSrc, onClose])

  const handleCancel = () => {
    setImageSrc(null); // Reset the image source
    onClose(); // Close the modal (this will also reset the file input)
  };

  return (
    <div className="cropper-wrapper">
        <div className="cropper-content">
          <div className="image-editor">
            {imageUrl && (
              <Cropper
                image={imageUrl}
                crop={crop}
                rotation={rotation}
                showGrid={false}
                zoom={zoom}
                aspect={1 / 1}
                onCropChange={setCrop}
                onRotationChange={setRotation}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
              />
            )}
          </div>
        </div>
        <div className="cropper-controls">
          <div className='cropper-actions'>
            <div className="cropper-zoom">
                <h3>Zoom</h3>
                <input 
                type="range"
                value={zoom}
                min={1}
                max={3}
                step={0.1}
                aria-labelledby="Zoom"
                onChange={(e) => setZoom(parseFloat(e.target.value))}
                />
            </div>
            <div className="cropper-rotation">
                <h3>Rotation</h3>
                <input 
                type="range"
                value={rotation}
                min={0}
                max={360}
                step={1}
                aria-labelledby="Rotation"
                onChange={(e) => setRotation(parseInt(e.target.value))}
                />
            </div>
          </div>
          <div className="cropper-actions">
            <button className="cancel-btn" onClick={handleCancel}>
              Cancel
            </button>
            <button onClick={showCroppedImage}>
              Crop image
            </button>
          </div>
        </div>
      </div>
  )
}

export default UploadImageBuilder;
